import $ from 'jquery';

export function acf_map()
{

	const google = window.google;
    /*
     *  new_map
     *  This function will render a Google Map onto the selected jQuery element
     */

    let map_styles = [{
        'featureType': 'all',
        'elementType': 'geometry',
        'stylers': [{
            'color': '#ffffff'
        }]
    },
    {
        'featureType': 'all',
        'elementType': 'labels.text.fill',
        'stylers': [{
                'gamma': '0.01'
            },
            {
                'lightness': '20'
            },
            {
                'color': '#426250'
            }
        ]
    },
    {
        'featureType': 'all',
        'elementType': 'labels.text.stroke',
        'stylers': [{
                'saturation': -31
            },
            {
                'lightness': -33
            },
            {
                'weight': 2
            },
            {
                'gamma': 0.8
            },
            {
                'color': '#ffffff'
            }
        ]
    },
    {
        'featureType': 'all',
        'elementType': 'labels.icon',
        'stylers': [{
            'visibility': 'off'
        }]
    },
    {
        'featureType': 'landscape',
        'elementType': 'geometry',
        'stylers': [{
                'lightness': 30
            },
            {
                'saturation': 30
            }
        ]
    },
    {
        'featureType': 'landscape.natural.landcover',
        'elementType': 'geometry.fill',
        'stylers': [{
            'color': '#caeebd'
        }]
    },
    {
        'featureType': 'poi',
        'elementType': 'geometry',
        'stylers': [{
            'saturation': 20
        }]
    },
    {
        'featureType': 'poi.business',
        'elementType': 'geometry.fill',
        'stylers': [{
            'color': '#caeebd'
        }]
    },
    {
        'featureType': 'poi.business',
        'elementType': 'labels',
        'stylers': [{
            'visibility': 'simplified'
        }]
    },
    {
        'featureType': 'poi.park',
        'elementType': 'geometry',
        'stylers': [{
                'lightness': 20
            },
            {
                'saturation': -20
            },
            {
                'color': '#caeebd'
            }
        ]
    },
    {
        'featureType': 'poi.school',
        'elementType': 'geometry.fill',
        'stylers': [{
            'color': '#caeebd'
        }]
    },
    {
        'featureType': 'poi.sports_complex',
        'elementType': 'geometry.fill',
        'stylers': [{
            'color': '#caeebd'
        }]
    },
    {
        'featureType': 'road',
        'elementType': 'geometry',
        'stylers': [{
                'lightness': 10
            },
            {
                'saturation': -30
            }
        ]
    },
    {
        'featureType': 'road',
        'elementType': 'geometry.stroke',
        'stylers': [{
                'saturation': 25
            },
            {
                'lightness': 25
            },
            {
                'color': '#f0f0f0'
            }
        ]
    },
    {
        'featureType': 'road',
        'elementType': 'labels',
        'stylers': [{
            'visibility': 'off'
        }]
    },
    {
        'featureType': 'road.highway',
        'elementType': 'geometry.fill',
        'stylers': [{
            'color': '#f2f1ed'
        }]
    },
    {
        'featureType': 'road.highway',
        'elementType': 'geometry.stroke',
        'stylers': [{
            'color': '#e6e6e6'
        }]
    },
    {
        'featureType': 'road.arterial',
        'elementType': 'geometry.stroke',
        'stylers': [{
            'color': '#e6e6e6'
        }]
    },
    {
        'featureType': 'road.arterial',
        'elementType': 'labels',
        'stylers': [{
            'visibility': 'off'
        }]
    },
    {
        'featureType': 'road.local',
        'elementType': 'geometry.stroke',
        'stylers': [{
                'color': '#e6e6e6'
            },
            {
                'saturation': '0'
            }
        ]
    },
    {
        'featureType': 'water',
        'elementType': 'all',
        'stylers': [{
            'lightness': -20
        }]
    },
    {
        'featureType': 'water',
        'elementType': 'geometry.fill',
        'stylers': [{
            'color': '#e9f0fe'
        }]
    }
];

    function new_map($el) {
        // var
        var $markers = $el.find('.marker');

        // vars
        var args = {
            zoom: 6,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: map_styles,
            mapTypeControl: false,
            disableDefaultUI: true
        };

        // create map
        var map = new google.maps.Map($el[0], args);

        // add a markers reference
        map.markers = [];

        // add markers
        $markers.each(function() {
            var url = $(this).attr('data-icon');

            let icon = {
                url: url,
                anchor: new google.maps.Point(12, 12),
                scaledSize: new google.maps.Size(24, 24)
            }

            add_marker($(this), map, icon);
        });

        // center map
        center_map(map);

        // return
        return map;
    }

    /*
     *  add_marker
     *  This function will add a marker to the selected Google Map
     */

    function add_marker($marker, map, icon) {

        // var
        var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

        // create marker
        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            animation: google.maps.Animation.DROP,
            icon: icon,
        });

        // add to array
        map.markers.push(marker);
    }

    /*
     *  center_map
     *  This function will center the map, showing all markers attached to this map
     */

    function center_map(map) {
        // vars
        var bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        $.each(map.markers, function(i, marker) {
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

            bounds.extend(latlng);
        });

        // only 1 marker?
        if (map.markers.length == 1) {

            // set center of map
            map.setCenter(bounds.getCenter());
            map.setZoom(14);
        } else {
            // fit to bounds
            map.fitBounds(bounds);
        }
    }

    /*
     *  document ready
     *  This function will render each map when the document is ready (page has loaded)
     */
    // global var
    var map = null;

    function maps() {

        $('.acf-map').each(function() {
            // create map
            map = new_map($(this));
        });
    }

    maps();
}



// WEBPACK FOOTER //
// ./scripts/modules/map.js